import styled from "styled-components";
import { Link } from "react-router-dom";

export const FooterSection = styled("footer")`
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 50%, #f1f2f3 100%);
  padding: 4rem 0 1.5rem;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #267A8D, #FEC409, #267A8D);
  }

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    right: -200px;
    width: 400px;
    height: 400px;
    background: radial-gradient(circle, rgba(38, 122, 141, 0.03) 0%, transparent 70%);
    border-radius: 50%;
    pointer-events: none;
  }
`;

export const Title = styled("h4")`
  font-size: 1.25rem;
  text-transform: capitalize;
  color: #267A8D;
  margin-bottom: 1rem;
  font-weight: 600;

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
  }
`;

export const ContactInfo = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  flex-direction: column;
  align-items: end;
  display: flex;
  gap: 0.5rem;

  a {
    color: #555;
    font-size: 15px;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.3s ease;
    padding: 0.25rem 0;

    &:hover {
      color: #267A8D;
      transform: translateX(-5px);
    }

    svg {
      color: #FEC409;
    }
  }
`;

export const SocialIconsContainer = styled.div`
  display: flex;
  gap: 0.75rem;
  justify-content: flex-start;

  a {
    width: 42px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, rgba(38, 122, 141, 0.1) 0%, rgba(254, 196, 9, 0.1) 100%);
    border-radius: 12px;
    border: 1px solid rgba(38, 122, 141, 0.1);
    transition: all 0.3s ease;

    svg {
      color: #267A8D;
      font-size: 1.1rem;
    }

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 8px 25px rgba(38, 122, 141, 0.2);
      background: linear-gradient(135deg, #267A8D 0%, #1a5a6e 100%);
      border-color: transparent;

      svg {
        color: white;
      }
    }
  }
`;

export const NavLink = styled(Link)`
  display: block;
  font-size: 1rem;
  margin-bottom: 0.75rem;
  color: #555;
  transition: all 0.3s ease;
  position: relative;
  padding-left: 0;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: 0;
    height: 2px;
    background: #FEC409;
    transition: width 0.3s ease;
    transform: translateY(-50%);
  }

  &:hover,
  &:active,
  &:focus {
    color: #267A8D;
    padding-left: 15px;

    &::before {
      width: 10px;
    }
  }
`;

export const Extra = styled("section")`
  background: transparent;
  position: relative;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 2rem;
  border-top: 1px solid rgba(38, 122, 141, 0.1);
  margin-top: 2rem;
`;

export const LogoContainer = styled("div")`
  display: flex;
  position: relative;
`;

export const Para = styled("div")`
  color: #555;
  font-size: 0.95rem;
  width: 100%;
  line-height: 1.8;
  margin-bottom: 1.5rem;
  position: relative;
  padding-left: 1rem;
  border-left: 3px solid transparent;
  border-image: linear-gradient(180deg, #267A8D, #FEC409) 1;

  strong {
    color: #267A8D;
    font-weight: 700;
  }

  &::first-line {
    font-weight: 600;
    color: #267A8D;
  }
`;

export const Large = styled(Link)`
  font-size: 16px;
  color: #555;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: capitalize;
  line-height: 24px;
  display: block;
  margin-bottom: 0.75rem;
  max-width: max-content;

  &:hover {
    color: #267A8D;
    padding-left: 8px;
  }
`;

export const Chat = styled("p")`
  color: #267A8D;
  max-width: fit-content;
  border-bottom: 2px solid #FEC409;
  cursor: pointer;
  margin-top: 1rem;
  transition: all 0.3s ease;
  font-weight: 500;
  padding-bottom: 2px;

  &:hover {
    border-bottom-color: #267A8D;
    color: #1a5a6e;
  }
`;

export const Empty = styled("div")`
  position: relative;
  height: 53px;
`;

export const FooterContainer = styled("div")`
  display: flex;
  justify-content: space-between;
  text-align: center;
  align-items: center;
  transition: all 0.3s ease;

  a {
    &:hover,
    &:active,
    &:focus {
      transform: scale(1.1);
    }
  }

  @media screen and (max-width: 769px) {
    width: auto;

    a:not(:last-child) {
      display: none;
    }
  }

  div {
    cursor: pointer;
    margin-right: 15px;
    width: 25px;
    height: 25px;

    &:hover {
      fill: #267A8D;
    }
  }
`;

export const Language = styled("h4")`
  font-size: 1.1rem;
  text-transform: capitalize;
  color: #267A8D;
  font-weight: 700;
  margin-bottom: 1.25rem;
  position: relative;
  padding-bottom: 0.75rem;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 40px;
    height: 3px;
    background: linear-gradient(90deg, #267A8D, #FEC409);
    border-radius: 2px;
  }

  @media screen and (max-width: 414px) {
    padding: 0 0 0.75rem 0;
    margin-top: 1rem;
  }
`;

export const Label = styled("label")`
  font-size: 1.25rem;
  text-transform: capitalize;
  color: #267A8D;
  display: block;
  margin-bottom: 2rem;
  font-family: "Motiva Sans Bold", serif;
  font-weight: 600;

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
    margin-bottom: 1rem;
  }
`;

export const LanguageSwitch = styled("div")`
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0.5rem;
  border-radius: 8px;

  &:hover,
  &:active,
  &:focus {
    transform: scale(1.1);
    background: rgba(38, 122, 141, 0.1);
  }
`;

export const LanguageSwitchContainer = styled("div")`
  display: flex;
  justify-content: space-between;
  width: 85px;
`;
